// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__WmHSQ"};